<script>
import { mapState } from 'vuex'
import { db, mixin, datestr, xhr } from './common.js'
export default {
  mixins: [mixin],
  data: () => ({
    dashboard: {}
  }),
  computed: {
    ...mapState([
      'user',
      'cachalogUrl'
    ]),
    updateTime () {
      if (this.dashboard.modified) {
        return datestr(this.dashboard.modified.toDate(), 'm/d H:i:s')
      } else {
        return false
      }
    },
    pages () {
      return (this.dashboard.pages || []).map(page => {
        page.to = {name: 'page', params: {pageId: page.id}}
        page.url = this.cachalogUrl + page.id
        page.status = page.publish ? 'public' : 'private'
        page.status = page.deleted ? 'deleted' : page.status
        page.date = datestr(page.created.toDate(), 'm/d H:i')
        return page
      })
    },
    users () {
      return (this.dashboard.users || []).map(user => {
        return {
          ...user,
          name: user.name || 'Anonymous',
          date: datestr(user.signed_in.toDate(), 'm/d H:i')
        }
      })
    },
    wishlists () {
      return (this.dashboard.wishlists || []).map(wishlist => {
        return {
          ...wishlist,
          date: datestr(wishlist.created.toDate(), 'm/d H:i'),
          total: {
            quantity: wishlist.items.reduce((a, b) => a + b.quantity, 0),
            amount: wishlist.items.reduce((a, b) => a + b.price.value * b.quantity, 0)
          }
        }
      })
    },
    sales () {
      return (this.dashboard.sales || []).map(sale => {
        return {
          ...sale,
          pages_ref: sale.pages_ref || {},
          date: datestr(sale.created.toDate(), 'm/d H:i'),
          total: {
            quantity: sale.items.reduce((a, b) => a + b.quantity, 0),
            amount: sale.items.reduce((a, b) => a + b.price.value * b.quantity, 0)
          }
        }
      })
    }
  },
  watch: {
    async 'user' (value) {
      if (value) {
        this.fetch()
      }
    }
  },
  methods: {
    async fetch () {
      const doc = await db.doc('dashboards/summary').get()
      this.dashboard = doc.data()
    },
    update () {
      xhr(this.cachalogUrl + '/update-dashboard', res => {
        this.fetch()
      })
    }
  },
  created () {
    if (this.user.uid) {
      this.fetch()
    }
    this.update()
  }
}
</script>

<template>
  <section class="dashboard">
    <header class="level is-mobile">
      <h1 class="title is-4">Dashboard</h1>
      <p>{{ updateTime }}</p>
      <button class="button is-small" @click="update">Update</button>
    </header>

    <section class="pages">
      <header>
        <h1 class="title is-5">Pages</h1>
      </header>
      <div>
        <ul>
          <li v-for="page in pages" :key="page.id">
            <router-link :to="page.to">
              <span>{{ page.title }}</span>
              <span>{{ page.status }}</span>
              <span>{{ page.date }}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </section>

    <section class="users">
      <header>
        <h1 class="title is-5">Users</h1>
      </header>
      <div>
        <ul>
          <li v-for="user in users" :key="user.uid">
            <span>{{ user.name }}</span>
            <span>{{ user.provider }}</span>
            <span>{{ user.date }}</span>
          </li>
        </ul>
      </div>
    </section>

    <section class="sales">
      <header>
        <h1 class="title is-5">Sales</h1>
      </header>
      <div>
        <ul>
          <li v-for="sale in sales" :key="sale.id">
            <span>{{ sale.pages_ref.id }}</span>
            <span>{{ sale.total.quantity.toLocaleString() }}</span>
            <span>{{ sale.total.amount.toLocaleString() }}</span>
            <span>{{ sale.date }}</span>
          </li>
        </ul>
      </div>
    </section>

    <section class="wishlists">
      <header>
        <h1 class="title is-5">Wishlists</h1>
      </header>
      <div>
        <ul>
          <li v-for="wishlist in wishlists" :key="wishlist.id">
            <span>{{ wishlist.pages_ref.id }}</span>
            <span>{{ wishlist.total.quantity.toLocaleString() }}</span>
            <span>{{ wishlist.total.amount.toLocaleString() }}</span>
            <span>{{ wishlist.date }}</span>
          </li>
        </ul>
      </div>
    </section>

  </section>
</template>

<style scoped>
section {
  margin: 1rem;
}
ul {
  margin: 1rem 0;
}
.pages ul li a,
.users ul li {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}
.wishlists ul li,
.sales ul li {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
}
.pages ul li a span,
.users ul li span,
.wishlists ul li span,
.sales ul li span {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard.vue